import React from 'react';
import { Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ResultsSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const studentResults = ['Comprenden las corrientes psicológicas con claridad', 'Analizan situaciones reales desde conceptos teóricos', 'Participan más en clase', 'Reflexionan sobre identidad y emociones', 'Conectan la Psicología con su vida cotidiana'];
  const teacherResults = ['Ahorrás horas de planificación', 'Enseñás con estructura y seguridad', 'Tenés todo organizado por unidad', 'Llegás sin estrés al cierre del año', 'Recuperás tiempo personal'];
  return;
}